import React from 'react';
import { Grid, Button } from '@material-ui/core/';
import { fontColors } from './DocumentWatermarkLookups';

const DocumentWatermarkColorPicker = ({ classes, onChangeColorPicker }) => {
  const colorButtons = fontColors.map(color => (
    <Grid item xs={4} sm={4} md={4} lg={4} key={color.code}>
      <Button
        className={classes.colorPickerInsideButton}
        style={{ backgroundColor: color.code }}
        onClick={onChangeColorPicker}
        id={color.code}
      />
    </Grid>
  ));
  return (
    <Grid container spacing={1}>
      {colorButtons}
    </Grid>
  );
};

export default DocumentWatermarkColorPicker;
